(() => {
  if (window.Shopify?.designMode || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const isMobile = window.matchMedia('(max-width: 749px)').matches;

  const selectors = [
    '#MainContent > .shopify-section',
    '#MainContent .product-grid__item',
    '#MainContent .hairah-look-card:not([hidden])',
  ].join(',');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.08,
      rootMargin: `0px 0px -${isMobile ? 16 : 7}% 0px`,
    }
  );

  const prepare = (root = document) => {
    const elements = root.matches?.(selectors) ? [root] : [...root.querySelectorAll(selectors)];

    elements.forEach((element) => {
      if (element.classList.contains('hairah-scroll-reveal') || element.closest('dialog')) return;

      element.classList.add('hairah-scroll-reveal');

      if (element.matches('#MainContent > .shopify-section')) {
        element.classList.add('hairah-scroll-reveal--section');
      } else {
        const siblings = [...element.parentElement.children].filter((child) => child.matches(selectors));
        const index = Math.max(0, siblings.indexOf(element));
        element.style.setProperty('--hairah-reveal-delay', `${Math.min(index % 4, 3) * (isMobile ? 85 : 65)}ms`);
      }

      observer.observe(element);
    });
  };

  prepare();
  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
})();
